import { ArgumentInfra3DSDKError } from "../error/ArgumentInfra3DSDKError";
export class ComponentService {
    constructor(container, navigator) {
        this._components = {};
        for (const componentName in ComponentService.registeredComponents) {
            if (!Object.prototype.hasOwnProperty.call(ComponentService.registeredComponents, componentName)) {
                continue;
            }
            const component = ComponentService.registeredComponents[componentName];
            this._components[componentName] = {
                active: false,
                component: new component(componentName, container, navigator),
            };
        }
    }
    static register(component) {
        if (ComponentService.registeredComponents[component.componentName] === undefined) {
            ComponentService.registeredComponents[component.componentName] = component;
        }
    }
    get coverActivated() {
        return this._coverActivated;
    }
    activateCover() {
        if (this._coverActivated) {
            return;
        }
        this._coverActivated = true;
        for (const componentName in this._components) {
            if (!Object.prototype.hasOwnProperty.call(this._components, componentName)) {
                continue;
            }
            const component = this._components[componentName];
            if (component.active) {
                component.component.deactivate();
            }
        }
    }
    deactivateCover() {
        if (!this._coverActivated) {
            return;
        }
        this._coverActivated = false;
        for (const componentName in this._components) {
            if (!Object.prototype.hasOwnProperty.call(this._components, componentName)) {
                continue;
            }
            const component = this._components[componentName];
            if (component.active) {
                component.component.activate();
            }
        }
    }
    activate(name) {
        this._checkName(name);
        this._components[name].active = true;
        if (!this._coverActivated) {
            this.get(name).activate();
        }
    }
    configure(name, conf) {
        this._checkName(name);
        this.get(name).configure(conf);
    }
    deactivate(name) {
        this._checkName(name);
        this._components[name].active = false;
        if (!this._coverActivated) {
            this.get(name).deactivate();
        }
    }
    get(name) {
        return this._components[name].component;
    }
    remove() {
        for (const componentName in this._components) {
            if (!Object.prototype.hasOwnProperty.call(this._components, componentName)) {
                continue;
            }
            this._components[componentName].component.deactivate();
        }
    }
    _checkName(name) {
        if (!(name in this._components)) {
            throw new ArgumentInfra3DSDKError(`Component does not exist: ${name}`);
        }
    }
}
ComponentService.registeredComponents = {};
//# sourceMappingURL=ComponentService.js.map